// PERSONA FRAGRANCE INTELLIGENCE — Phase 2.4 keys (Dashboard Four Paths)
export const P24 = {
  en: {
    dash_paths_eyebrow: "YOUR FOUR PATHS",
    dash_paths_title: "Your Fragrance Intelligence Journey",
    dash_paths_sub:
      "Learn fragrance. Explore intelligence. Create personalized scent. Build and discover through a professional fragrance house.",
    dash_path_learn_desc:
      "Structured learning in perfumery, fragrance knowledge and applied fragrance technology.",
    dash_path_explore_desc:
      "Explore fragrance knowledge, discuss olfactory concepts and receive conversational fragrance guidance.",
    dash_path_create_desc:
      "Access the official PERSONA technology for personalized fragrance research and formulation.",
    dash_path_craft_desc:
      "Fragrance house services, professional formulation, manufacturing solutions, fragrance materials and curated fragrance creations.",
    dash_path_learn_cta: "START LEARNING",
    dash_path_explore_cta: "ENTER AI PERFUMER",
    dash_path_create_cta: "ACCESS PERSONA PERFUMERY TECH",
    dash_path_craft_cta: "EXPLORE TWFH",
    dash_your_activity: "Your Activity",
  },
  id: {
    dash_paths_eyebrow: "EMPAT JALUR ANDA",
    dash_paths_title: "Perjalanan Intelijen Wewangian Anda",
    dash_paths_sub:
      "Pelajari wewangian. Jelajahi intelijen. Ciptakan wewangian personal. Bangun dan temukan melalui fragrance house profesional.",
    dash_path_learn_desc:
      "Pembelajaran terstruktur tentang perfumery, pengetahuan wewangian, dan teknologi wewangian terapan.",
    dash_path_explore_desc:
      "Jelajahi pengetahuan wewangian, diskusikan konsep olfaktori, dan dapatkan panduan wewangian percakapan.",
    dash_path_create_desc:
      "Akses teknologi resmi PERSONA untuk riset dan formulasi wewangian personal.",
    dash_path_craft_desc:
      "Layanan fragrance house, formulasi profesional, solusi manufaktur, bahan wewangian, dan kreasi wewangian terkurasi.",
    dash_path_learn_cta: "MULAI BELAJAR",
    dash_path_explore_cta: "MASUK KE PERSONA AI PERFUMER",
    dash_path_create_cta: "AKSES PERSONA PERFUMERY TECH",
    dash_path_craft_cta: "JELAJAHI TWFH",
    dash_your_activity: "Aktivitas Anda",
  },
  fr: {
    dash_paths_eyebrow: "VOS QUATRE VOIES",
    dash_paths_title: "Votre voyage d'intelligence olfactive",
    dash_paths_sub:
      "Apprendre. Explorer. Créer votre parfum personnalisé. Construire et découvrir à travers une maison de parfum professionnelle.",
    dash_path_learn_desc:
      "Apprentissage structuré en parfumerie, savoir olfactif et technologie olfactive appliquée.",
    dash_path_explore_desc:
      "Explorez le savoir olfactif, discutez de concepts et recevez un guidage olfactif conversationnel.",
    dash_path_create_desc:
      "Accédez à la technologie officielle PERSONA pour la recherche et la formulation olfactive personnalisée.",
    dash_path_craft_desc:
      "Services de maison de parfum, formulation professionnelle, solutions de fabrication, matières premières et créations olfactives sélectionnées.",
    dash_path_learn_cta: "COMMENCER À APPRENDRE",
    dash_path_explore_cta: "ENTRER DANS AI PERFUMER",
    dash_path_create_cta: "ACCÉDER À PERSONA PERFUMERY TECH",
    dash_path_craft_cta: "EXPLORER TWFH",
    dash_your_activity: "Votre activité",
  },
};

export default P24;
